<template>
  <div class="content">
    <div class="content-wrapper" v-if="bookAvailable">
      <div
        class="content-item"
        v-for="(item,index) in navigation.toc"
        @click="jumpTo(item.href)"
        :key="index"
      >
        <span class="text">{{item.label}}</span>
      </div>
    </div>
    <div class="empty" v-else>加载中...</div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    ifShowContent: {
      type: Boolean,
      default: false
    },
    navigation: Object,
    bookAvailable: Boolean
  },
  data() {
    return {};
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {},

  methods: {
    jumpTo(target) {
      this.$emit("jumpTo", target);
    }
  },

  watch: {}
};
</script>
<style lang='less' scoped>
.content {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 102;
  width: 320px;
  height: 100%;
  background: #fff;
  .content-wrapper {
    display: flex;
    flex-direction: column;
    padding: 0 0 0 20px;
    box-sizing: border-box;
    height: 100%;
    padding: 30px 0 0 0;
    overflow: auto;
    .content-item {
      display: flex;
      height: 30px;
      margin: 0 0 4px 0;
      align-items: center;
      .text {
          display: block;
          height: 100%;
        font-size: 14px;
        padding: 0 0 0 30px;
        line-height: 30px;
        cursor: pointer;
        width: 100%;
      }
      .text:hover{
          background: rgba(247,247,247,1);;
      }
    }
  }
  .empty {
    display: flex;
    width: 100%;
    height: 100%;
    font-size: 24px;
  }
}
</style>